import page from './LoginPage.vue'
export default page
